import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  transform(value: any, arg?: string) {
    switch (arg) {
      case 'url':
        return value;
        return this._sanitizer.bypassSecurityTrustStyle(`url${value}`);
      default:
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
    }
  }
}
